function NotFound({ registered }) {
  return (
    <p>Not Found...</p>
  );
}

export default NotFound;